import { IPagedList } from "@/types";

export class ObjectUtil {
    /**
     * Finds the value for the specified @param key using a case-insensitive search
     *
     * @param {*} object
     * @param {*} key
     * @returns string|undefined
     */
    public static findValueByKey(object: any, key: string | null | undefined): any | undefined {
        if (key && object) {
            const value = object[key];

            if (typeof value !== "undefined") {
                return value;
            }

            const keyToMatch = key.toLowerCase();

            const propName = Object.keys(object).find((k) => keyToMatch === k.toLowerCase());

            if (propName) {
                return object[propName];
            }
        }

        return undefined;
    }

    /**
     * Creates an instance of type T with any specified @param defaultProps
     *
     * NOTE: This is intentionally circumventing type checking, so only use this
     * for mocking objects or other scenarios when only specific properties of an
     * object type are needed.
     * @param {*} [defaultProps]
     * @returns {T}
     */
    public static createInstance<T = any>(defaultProps?: Partial<T>): T {
        return {
            ...defaultProps,
        } as any;
    }

    public static emptyPagedList<T = any>(defaultProps?: Partial<IPagedList<T>>): IPagedList<T> {
      return ObjectUtil.createInstance<IPagedList<T>>({
        Items: [],
        Page: 1,
        PageSize: 20,
        Pages: 1,
        Total: 0,
        ... defaultProps
      })
    }
}
